<template>
  <div id="app-setting">
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Settings</span>
        </li>
      </ul>
    </div>

    <div class="app-setting-tab-scroll">
      <vs-row class="mb-6 setting-title cursor-pointer" @click.native="showGeneralSetting">
        <div v-if="showGeneral == false">
          <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <div v-else>
          <feather-icon icon="ChevronUpIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <h3 class="font-bold">General Settings</h3>
      </vs-row>
      <transition name="list">
        <div v-show="showGeneral">
          <vs-tabs position="left" class="app-setting main-tabs" id="app-settings">
            <vs-tab label="Business Profile">
              <vs-profile @LoadDataComplete="loadDataComplete"></vs-profile>
            </vs-tab>
            <vs-tab label="Business Work Hour">
              <vs-business-work-hour></vs-business-work-hour>
            </vs-tab>
            <vs-tab label="Change Password">
              <vs-change-password></vs-change-password>
            </vs-tab>
            <vs-tab label="Service & Staff Setting">
              <vs-service-staff-setting></vs-service-staff-setting>
            </vs-tab>
            <vs-tab label="Ticket Setting">
              <vs-ticket-setting></vs-ticket-setting>
            </vs-tab>
            <vs-tab label="Checkout Setting">
              <vs-checkout-setting></vs-checkout-setting>
            </vs-tab>
            <vs-tab label="Store Policies">
              <vs-term-policy></vs-term-policy>
            </vs-tab>
            <vs-tab label="Passcode Setting">
              <passcode-setting></passcode-setting>
            </vs-tab>
            <vs-tab label="GCI Station Language">
              <gci-station-language></gci-station-language>
            </vs-tab>
            <vs-tab label="Store Rating on GCI App">
              <store-rating-on-gci-app></store-rating-on-gci-app>
            </vs-tab>
            <vs-tab label="SMS Content">
              <vs-appointment-sms-content></vs-appointment-sms-content>
            </vs-tab>
            <vs-tab label="SMS Count" v-if="smsCount && smsCount.sms_count_active == 1">
              <sms-count-setting></sms-count-setting>
            </vs-tab>
            <!-- <vs-tab label="Tax Setting" v-if="config.pos_feature == 1">
              <tax-setting></tax-setting>
            </vs-tab>
            <vs-tab label="Standalone PAX Mode">
              <standalone-pax-mode></standalone-pax-mode>
            </vs-tab> -->
            <!-- <vs-tab label="Go Booking service price">
              <vs-appointment-active-price @LoadDataComplete="loadDataComplete"></vs-appointment-active-price>
            </vs-tab>
            <vs-tab label="Active Web Booking" v-if="config.appointment_feature == 1">
              <vs-appointment-setting @LoadDataComplete="loadDataComplete"></vs-appointment-setting>
            </vs-tab> -->
            <!-- <vs-tab label="SMS content" v-if="config.appointment_feature == 1">
              <vs-appointment-sms-content></vs-appointment-sms-content>
            </vs-tab> -->
          </vs-tabs>
        </div>
      </transition>
      <!-- <vs-row
        class="mt-6 mb-6 setting-title cursor-pointer"
        @click.native="showAppointmentSetting"
        v-if="config.appointment_feature == 1"
      >
        <div v-if="showAppointment == false">
          <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <div v-else>
          <feather-icon icon="ChevronUpIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <h3 class="font-bold">Appointment Settings</h3>
      </vs-row>
      <transition name="list" v-if="config.appointment_feature == 1">
        <div v-show="showAppointment">
          <vs-tabs position="left" class="app-setting" id="appointment-setting">
            <vs-tab label="Activate web booking">
              <vs-appointment-setting @LoadDataComplete="loadDataComplete"></vs-appointment-setting>
            </vs-tab>

            <vs-tab label="SMS content">
              <vs-appointment-sms-content></vs-appointment-sms-content>
            </vs-tab>
          </vs-tabs>
        </div>
      </transition> -->
      <vs-row class="mt-6 mb-6 setting-title cursor-pointer" @click.native="showOrderSetting" v-if="config.order_feature == 1">
        <div v-if="showOrder == false">
          <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <div v-else>
          <feather-icon icon="ChevronUpIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <h3 class="font-bold">Order Settings</h3>
      </vs-row>
      <transition name="list" v-if="config.order_feature == 1">
        <div v-show="showOrder">
          <vs-tabs position="left" class="app-setting main-tabs" id="order-setting">
            <vs-tab label="Active Order Online">
              <vs-order-setting @LoadDataComplete="loadDataComplete"></vs-order-setting>
            </vs-tab>
          </vs-tabs>
        </div>
      </transition>

      <vs-row class="my-6 setting-title cursor-pointer" @click.native="showPOSSetting" v-if="config.pos_feature == 1">
        <div v-if="showPOS == false">
          <feather-icon icon="ChevronDownIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <div v-else>
          <feather-icon icon="ChevronUpIcon" svgClasses="h-6 w-6 color-black" class="mr-3" />
        </div>
        <h3 class="font-bold">Go POS Settings</h3>
      </vs-row>
      <transition name="list" v-if="config.pos_feature == 1">
        <div v-show="showPOS">
          <vs-tabs position="left" class="app-setting main-tabs" id="pos-settings">
            <vs-tab label="Tax Setting" v-if="config.pos_feature == 1">
              <tax-setting></tax-setting>
            </vs-tab>
            <vs-tab label="Standalone PAX Mode">
              <standalone-pax-mode></standalone-pax-mode>
            </vs-tab>
            <vs-tab label="Staff Receipt">
              <staff-receipt></staff-receipt>
            </vs-tab>
            <vs-tab label="Cash Discount Mode">
              <cash-discount-mode></cash-discount-mode>
            </vs-tab>
            <vs-tab label="Service Fee">
              <service-fee-setting></service-fee-setting>
            </vs-tab>
            <vs-tab label="Tip On Device">
              <tip-on-device></tip-on-device>
            </vs-tab>
            <vs-tab label="Print On Clover">
              <print-on-clover-setting></print-on-clover-setting>
            </vs-tab>
            <vs-tab label="QR Code" v-if="config && config.qrCode == 1">
              <qr-code-setting></qr-code-setting>
            </vs-tab>
            <vs-tab label="Flex Checkin">
              <flex-checkin-setting></flex-checkin-setting>
            </vs-tab>
            <vs-tab label="Tip Setting">
              <tip-setting></tip-setting>
            </vs-tab>
            <!-- <vs-tab label="Surcharge">
              <surcharge-setting></surcharge-setting>
            </vs-tab> -->
          </vs-tabs>
        </div>
      </transition>

      <!-- <vs-tabs position="left" class="mt-base app-setting sms-setting-tab main-tabs" id="sms-settings" v-model="sms_tab" v-if="config.appointment_feature == 1">
        <vs-tab label="SMS content" v-if="config.appointment_feature == 1">
          <vs-appointment-sms-content></vs-appointment-sms-content>
        </vs-tab>
        <vs-tab label="SMS content">
          <div></div>
        </vs-tab>
      </vs-tabs> -->
    </div>
  </div>
</template>

<script>
import PasscodeSetting from "../../components/AppSetting/PasscodeSetting";
import TipSetting from '../../components/AppSetting/TipSetting.vue';

export default {
  components: {
    PasscodeSetting, TipSetting
  },
  data() {
    return {
      good_review: true,
      showGeneral: true,
      showAppointment: false,
      showOrder: false,
      showPOS: false,
      windowWidth: window.innerWidth,
      loaded_data_num: 0,
      isOpenLoading: false,
      sms_tab: 1,
    };
  },
  watch: {
    windowWidth: {
      immediate: true,
      deep: true,
      handler() {
        this.setTabPosition();
      },
    },
    loaded_data_num: {
      immediate: true,
      handler() {
        if (this.loaded_data_num > 0) {
          this.closeLoading();
        } else {
          this.openLoadingInDiv();
        }
      },
    },
    sms_tab: {
      immediate: true,
      handler() {
        if(this.sms_tab == 0 && this.config.appointment_feature == 1) {
          this.showAppointment = false;
          this.showOrder = false;
          this.showGeneral = false;
          this.showPOS = false;
        }
      }
    }
  },
  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Get data app settings failed",
            acceptText: "OK",
          });
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    showGeneralSetting() {
      if (this.showGeneral == true) {
        this.showGeneral = false;
      } else {
        this.showGeneral = true;
        this.showAppointment = false;
        this.showOrder = false;
        this.showPOS = false;
        this.sms_tab = 1;
      }
    },
    showAppointmentSetting() {
      if (this.showAppointment == true) {
        this.showAppointment = false;
      } else {
        this.showAppointment = true;
        this.showOrder = false;
        this.showGeneral = false;
        this.showPOS = false;
        this.sms_tab = 1;
      }
    },
    showOrderSetting() {
      if (this.showOrder == true) {
        this.showOrder = false;
      } else {
        this.showAppointment = false;
        this.showOrder = true;
        this.showGeneral = false;
        this.showPOS = false;
        this.sms_tab = 1;
      }
    },
    showPOSSetting() {
      if (this.showPOS == true) {
        this.showPOS = false;
      } else {
        this.showAppointment = false;
        this.showOrder = false;
        this.showGeneral = false;
        this.showPOS = true;
        this.sms_tab = 1;
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    setTabPositionForElement(tab_elem) {
      if (tab_elem) {
        if (this.windowWidth > 800) {
          tab_elem.classList.remove("vs-tabs-position-top");
          tab_elem.classList.add("vs-tabs-position-left");
        } else {
          tab_elem.classList.remove("vs-tabs-position-left");
          tab_elem.classList.add("vs-tabs-position-top");
        }
      }
    },
    setTabPosition() {
      let app_settings = document.getElementById("app-settings");
      let appointment_setting = document.getElementById("appointment-setting");
      let order_setting = document.getElementById("order-setting");
      let sms_setting = document.getElementById("sms-settings");
      let pos_setting = document.getElementById("pos-settings");
      this.setTabPositionForElement(app_settings);
      this.setTabPositionForElement(appointment_setting);
      this.setTabPositionForElement(order_setting);
      this.setTabPositionForElement(sms_setting);
      this.setTabPositionForElement(pos_setting);
    },
    loadDataComplete() {
      this.loaded_data_num++;
    },
  },
  // computed:{
  //   workingHourData(){
  //     return
  //   }
  // },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.setTabPosition();
    });
  },
  created() {
    this.$store.dispatch("appSetting/GET_BUSINESS_WORK_HOUR").then(() => {
      this.loaded_data_num++;
    });
  },
  computed: {
    config() {
      console.log(this.$store.getters['auth/config']);
      return this.$store.getters["auth/config"];
    },
    smsCount() {
      return this.$store.getters["smsCount/smsCount"];
    },
  },
};
</script>
